var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"about"},[_c('div',{staticClass:"title f-f-sans"},[_c('p',[_vm._v(_vm._s(_vm.$t("message.about-title")))])]),_c('div',{staticClass:"content"},[_c('p',{staticClass:"f-f-sans"},[_vm._v(" "+_vm._s(_vm.$t("message.about-full"))+" ")])])]),_c('Gallary')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }